import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateTicketsComponent } from './create-tickets/create-tickets.component';
import { MyTicketsComponent } from './my-tickets/my-tickets.component';
import { Routes, RouterModule } from '@angular/router';
import { OverDueTicketsComponent } from './over-due-tickets/over-due-tickets.component';
import { UpComingComponent } from './up-coming/up-coming.component';
import {CdkTableModule} from '@angular/cdk/table';
import {MatTableModule} from '@angular/material/table'
import { MatFileUploadModule } from 'mat-file-upload';
import { TicketDetailComponent } from './ticket-detail/ticket-detail.component';
import { AuthGuard } from '../_helpers/auth.guard';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AllTicketsComponent } from './all-tickets/all-tickets.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

const routes: Routes = [
  //{ path:'',component:MyTicketsComponent},
  {path: 'TicketDetail/:ticketID', component:TicketDetailComponent},
  { path:'my-tickets',component:MyTicketsComponent, canActivate: [AuthGuard] },
  { path:'all-tickets',component:AllTicketsComponent, canActivate: [AuthGuard] },
  { path:'CreateTickets',component:CreateTicketsComponent,canActivate: [AuthGuard]},
  { path: 'overDueTickets', component: OverDueTicketsComponent, canActivate: [AuthGuard]},
  { path:'upComingTickets',component:UpComingComponent,},  
];

@NgModule({
  declarations: [
      CreateTicketsComponent,
      MyTicketsComponent,
      OverDueTicketsComponent,
      UpComingComponent, 
      AllTicketsComponent,
      TicketDetailComponent],

  imports: [RouterModule.forChild(routes),
    CommonModule,CdkTableModule,MatTableModule,MatFileUploadModule,MatFormFieldModule,MatSelectModule,MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,  
    MatIconModule,  
    MatButtonModule,  
    MatCardModule,  
    MatProgressBarModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ]
})
export class TicketsModule { } 
